import * as action_types from "./constants";
import { getTaskDetailType, getTaskFormType, WODetailType } from "./types";

export type myCompanyState = {
  taskListData: {
    loader: boolean;
    data: [] | null;
    count: number;
  };
  taskDetailData: {
    loader: boolean;
    data: getTaskDetailType | null;
  };
  taskFormData: {
    loader: boolean;
    data: getTaskFormType[] | null;
  };
  workOrdersListData: {
    loader: boolean;
    data: [] | null;
    count: number;
  };
  woDetailData: {
    loader: boolean;
    data: WODetailType | null;
  };
};

const initialState: myCompanyState = {
  taskListData: {
    loader: true,
    data: null,
    count: 0,
  },
  taskDetailData: {
    loader: true,
    data: null,
  },
  taskFormData: {
    loader: true,
    data: null,
  },
  workOrdersListData: {
    loader: true,
    data: null,
    count: 0,
  },
  woDetailData: {
    loader: true,
    data: null,
  },
};

type MyCompanyActionType =
  | {
      type: typeof action_types.GET_TASKS_LISTING;
      data: { payload: []; loading: boolean; count: number };
    }
  | {
      type: typeof action_types.GET_TASKS_DETAIL;
      data: { payload: getTaskDetailType | null; loading: boolean };
    }
  | {
      type: typeof action_types.TASK_FORM_DATA;
      data: { payload: getTaskFormType[]; loading: boolean };
    }
  | {
      type: typeof action_types.GET_WORK_ORDERS_LISTING;
      data: { payload: []; loading: boolean; count: number };
    }
  | {
      type: typeof action_types.GET_WORK_ORDERS_DETAIL;
      data: { payload: WODetailType | null; loading: boolean };
    };

const myCompanyReducer = (
  state = initialState,
  action: MyCompanyActionType
): myCompanyState => {
  const { type, data } = action;
  switch (type) {
    case action_types.GET_TASKS_LISTING:
      return {
        ...state,
        taskListData: {
          loader: data?.loading,
          data: data?.payload,
          count: data?.count,
        },
      };

    case action_types.GET_TASKS_DETAIL:
      return {
        ...state,
        taskDetailData: {
          loader: data?.loading,
          data: data?.payload,
        },
      };

    case action_types.TASK_FORM_DATA:
      return {
        ...state,
        taskFormData: {
          loader: data?.loading,
          data: data?.payload,
        },
      };

    case action_types.GET_WORK_ORDERS_LISTING:
      return {
        ...state,
        workOrdersListData: {
          loader: data?.loading,
          data: data?.payload,
          count: data?.count,
        },
      };

    case action_types.GET_WORK_ORDERS_DETAIL:
      return {
        ...state,
        woDetailData: {
          loader: data?.loading,
          data: data?.payload,
        },
      };

    default:
      return state;
  }
};

export default myCompanyReducer;
